import { i18n } from "apps/web/src/i18n";

export const mealPlanChooseAthletesFormToSaveTooltips = (selectedAthleteIds: string[]) => {
  let tooltips: string[] = [];
  if (selectedAthleteIds.length === 0) {
    tooltips.push(i18n.t("mealPlan.chooseAthletes.validation.selectAtLeastOne"));
  }
  return tooltips;
};
